import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { tokenManager } from '../utils/tokenManager';
import Loader from '../loader';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    const [isValid, setIsValid] = useState(false);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const validateAuth = () => {
            // Check for token first (more secure)
            const token = tokenManager.getAccessToken();
            
            // Fallback to legacy user data check
            const userData = localStorage.getItem('user_sis');
            
            // Validate that we have either a token or valid user data
            if (token) {
                setIsValid(true);
            } else if (userData) {
                try {
                    const parsed = JSON.parse(userData);
                    // Check if we have at least schoolID and schoolname (minimum required)
                    if (parsed && parsed.schoolID && parsed.schoolname) {
                        setIsValid(true);
                    } else {
                        setIsValid(false);
                    }
                } catch (e) {
                    setIsValid(false);
                }
            } else if (user && user.schoolID && user.schoolname) {
                // User from context is valid
                setIsValid(true);
            } else {
                setIsValid(false);
            }
            setChecking(false);
        };

        if (!loading) {
            validateAuth();
        }
    }, [user, loading]);

    if (loading || checking) {
        return <Loader />;
    }

    if (!isValid) {
        // Redirect to login page but save the attempted url
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }

    return children;
};

export default ProtectedRoute; 